import type { DoodOpenCheck } from '@core/models/check.model';

import { PAT_DEFAULT_MOCK_CHECK_DATA, PAT_MOCK_CHECK_CANCELLED_DATA } from './pat-mock-check.data';

/** Default check injected in PAT mock mode (?checkId=test). */
export const PAT_DEFAULT_MOCK_CHECK = PAT_DEFAULT_MOCK_CHECK_DATA as unknown as DoodOpenCheck;

export const PAT_DEFAULT_MOCK_CHECK_JSON = JSON.stringify(PAT_DEFAULT_MOCK_CHECK, null, 2);

/** Variant for testing payment-refused confirmation screen. */
export const PAT_MOCK_CHECK_CANCELLED = PAT_MOCK_CHECK_CANCELLED_DATA as unknown as DoodOpenCheck;

export const PAT_MOCK_CHECK_CANCELLED_JSON = JSON.stringify(PAT_MOCK_CHECK_CANCELLED, null, 2);
